/**
 * StatsPanel - World statistics display
 * Shows population, food, generation, and other metrics
 */

import { useSimulationStore } from '../stores/simulationStore';
import { CollapsiblePanel } from './ui';

export function StatsPanel() {
  const stats = useSimulationStore((state) => state.stats);
  const tick = useSimulationStore((state) => state.tick);
  const actualTPS = useSimulationStore((state) => state.actualTPS);

  // Determine TPS status for highlighting
  const tpsStatus = actualTPS >= 25 ? '' : actualTPS >= 15 ? 'stat-warning' : 'stat-danger';

  return (
    <CollapsiblePanel id="stats" title="Estadisticas">
      <div className="stats">
        <div className="stat stat-highlighted">
          <span className="stat-label">Poblacion</span>
          <span className="stat-value">{stats?.population ?? 0}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Generacion</span>
          <span className="stat-value">{stats?.generation?.toFixed(1) ?? '0.0'}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Especies</span>
          <span className="stat-value">{stats?.species ?? 0}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Comida</span>
          <span className="stat-value">{stats?.food ?? 0}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Tick</span>
          <span className="stat-value">{tick}</span>
        </div>
        <div className={`stat ${tpsStatus}`}>
          <span className="stat-label">TPS</span>
          <span className="stat-value">{(actualTPS ?? 0).toFixed(1)}</span>
        </div>
      </div>
    </CollapsiblePanel>
  );
}
